// Chantiers qualité routes — entry point in the vertical navigation, gated by CHANTIER:read.
export default [
  {
    path: '/chantiers',
    name: 'chantiers-list',
    component: () => import('@/views/chantiers/ChantiersListView.vue'),
    meta: {
      pageTitle: 'Chantiers qualité',
      rights: ['CHANTIER:read'],
      breadcrumb: [
        { text: 'Chantiers qualité', active: true },
      ],
    },
  },
  {
    path: '/chantiers/recap-public',
    name: 'chantiers-recap-public',
    component: () => import('@/views/chantiers/ChantiersRecapPublicView.vue'),
    meta: {
      pageTitle: 'Récap des chantiers',
      rights: ['CHANTIER:read'],
      breadcrumb: [
        { text: 'Chantiers qualité', to: { name: 'chantiers-list' } },
        { text: 'Récap', active: true },
      ],
    },
  },
  {
    path: '/chantiers/bulletin',
    name: 'chantiers-bulletin',
    component: () => import('@/views/chantiers/ChantiersBulletinView.vue'),
    meta: {
      layout: 'full',
      pageTitle: 'Bulletin de synthèse',
      rights: ['CHANTIER:read'],
    },
  },
  {
    path: '/chantiers/:id',
    name: 'chantier-detail',
    component: () => import('@/views/chantiers/ChantierDetailView.vue'),
    meta: {
      pageTitle: 'Détail du chantier',
      breadcrumb: [
        { text: 'Chantiers qualité', to: { name: 'chantiers-list' } },
        { text: 'Détail', active: true },
      ],
    },
  },
  {
    path: '/chantiers/:chantierId/plans/:planId',
    name: 'chantier-plan-detail',
    component: () => import('@/views/chantiers/PlanActionDetailView.vue'),
    meta: {
      pageTitle: 'Plan d\'action',
      breadcrumb: [
        { text: 'Chantiers qualité', to: { name: 'chantiers-list' } },
        { text: 'Plan d\'action', active: true },
      ],
    },
  },
  {
    path: '/chantiers/:chantierId/plans/:planId/notes/nouvelle',
    name: 'chantier-plan-note-new',
    component: () => import('@/views/chantiers/NoteFormView.vue'),
    meta: {
      pageTitle: 'Nouvelle note de réunion',
      breadcrumb: [
        { text: 'Chantiers qualité', to: { name: 'chantiers-list' } },
        { text: 'Nouvelle note', active: true },
      ],
    },
  },
  {
    path: '/chantiers/:chantierId/plans/:planId/notes/:noteId',
    name: 'chantier-plan-note-detail',
    component: () => import('@/views/chantiers/NoteDetailView.vue'),
    meta: {
      pageTitle: 'Note de réunion',
      breadcrumb: [
        { text: 'Chantiers qualité', to: { name: 'chantiers-list' } },
        { text: 'Note', active: true },
      ],
    },
  },
  {
    path: '/chantiers/:id/recap',
    name: 'chantier-recap',
    component: () => import('@/views/chantiers/ChantierRecapView.vue'),
    meta: {
      pageTitle: 'Récapitulatif',
      rights: ['CHANTIER:read'],
      breadcrumb: [
        { text: 'Chantiers qualité', to: { name: 'chantiers-list' } },
        { text: 'Récapitulatif', active: true },
      ],
    },
  },
  {
    path: '/chantiers/admin/categories',
    name: 'chantiers-admin-categories',
    component: () => import('@/views/chantiers/admin/CategoriesChantierAdmin.vue'),
    meta: {
      pageTitle: 'Catégories de chantier',
      rights: ['CHANTIER:admin'],
      breadcrumb: [
        { text: 'Chantiers qualité', to: { name: 'chantiers-list' } },
        { text: 'Administration', active: true },
        { text: 'Catégories', active: true },
      ],
    },
  },
  {
    path: '/chantiers/admin/origines',
    name: 'chantiers-admin-origines',
    component: () => import('@/views/chantiers/admin/OriginesChantierAdmin.vue'),
    meta: {
      pageTitle: 'Origines de chantier',
      rights: ['CHANTIER:admin'],
      breadcrumb: [
        { text: 'Chantiers qualité', to: { name: 'chantiers-list' } },
        { text: 'Administration', active: true },
        { text: 'Origines', active: true },
      ],
    },
  },
  {
    path: '/chantiers/admin/archived',
    name: 'chantiers-admin-archived',
    component: () => import('@/views/chantiers/admin/ArchivedChantierAdmin.vue'),
    meta: {
      pageTitle: 'Chantiers archivés',
      rights: ['CHANTIER:admin'],
      breadcrumb: [
        { text: 'Chantiers qualité', to: { name: 'chantiers-list' } },
        { text: 'Administration', active: true },
        { text: 'Chantiers archivés', active: true },
      ],
    },
  },
]
